export const IS_INVERTED = true;
